__turbopack_context__.v({
  "breadcrumbs": "Hero-module__psssnW__breadcrumbs",
  "hero": "Hero-module__psssnW__hero",
  "heroContent": "Hero-module__psssnW__heroContent",
  "heroImageContainer": "Hero-module__psssnW__heroImageContainer",
  "left": "Hero-module__psssnW__left",
  "noImage": "Hero-module__psssnW__noImage",
  "title": "Hero-module__psssnW__title",
});
